export default __webpack_public_path__ + "static/media/15.69bc5cb2.jpeg";